import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import NumberUtils from '../../utils/NumberUtils';

class AccountPreferenceCards extends React.Component {
  constructor(props) {
    super(props);
    this.upButtonClick = this.upButtonClick.bind(this);
    this.downButtonClick = this.downButtonClick.bind(this);
  }

  downButtonClick() {
    this.props.downButtonClick(this.props.cardDetails.id);
  }

  upButtonClick() {
    this.props.upButtonClick(this.props.cardDetails.id);
  }

  render() {
    const { cardDetails, upReorderButton, downReorderButton } = this.props;
    return (
      <li className="c-account c-account--preferences l-preferences">
        <div className="l-preferences__account">
          <h3 className="c-account__name">{cardDetails.displayName}</h3>

          <dl className="c-account__defs">
            <dt className="c-account__term">Sortcode</dt>
            <dd className="c-account__sortno">{cardDetails.sortCode}</dd>
            <dt className="c-account__term">Account number</dt>
            <dd className="c-account__accountno">
              {cardDetails.accountNumber}
            </dd>
            <dt className="c-account__term">Balance</dt>
            <dd className="c-account__balance">
              {_.isEmpty(cardDetails.balances)
                ? ''
                : NumberUtils.appendCurrency(
                    '{}',
                    cardDetails.balances[0].amount.value
                  )}
            </dd>
          </dl>
        </div>
        <div className="l-preferences__preferences">
          <div className="c-account__controls">
            <span className="u-visually-hidden off-screen">Change order </span>
            <button
              disabled={upReorderButton}
              className="c-account__controls-top c-btn c-btn--secondary c-btn--icon-only"
              onClick={this.upButtonClick}
            >
              <span className="icon icon-reorder-up" />
              <span className="u-visually-hidden off-screen">Move Up</span>
            </button>

            <button
              disabled={downReorderButton}
              className="c-account__controls-bottom c-btn c-btn--secondary c-btn--icon-only"
              onClick={this.downButtonClick}
            >
              <span className="icon icon-reorder-down" />
              <span className="u-visually-hidden off-screen">Move Down</span>
            </button>
          </div>
        </div>
      </li>
    );
  }
}

AccountPreferenceCards.propTypes = {
  cardDetails: PropTypes.object,
  accountId: PropTypes.string,
  upButtonClick: PropTypes.func,
  downButtonClick: PropTypes.func,
  upReorderButton: PropTypes.bool,
  downReorderButton: PropTypes.bool,
};

export default AccountPreferenceCards;
